import React from 'react';
// import "../../assets/css/master.css";

import TemplateDashboard from "../../../components/TemplateDashboard";
import RingoverLlamadasContent from './components/RingoverLlamadasContent';

const RingoverLlamadasListado = () => {

    return (
        <>

            <TemplateDashboard>
                <RingoverLlamadasContent />
            </TemplateDashboard>

        </>
    )
};

export default RingoverLlamadasListado;